<template>
  <div class="wrapper layout">
  </div>
</template>

<script>

export default {
  components: { },
  data() {
    return {};
  },
  created() {
    this.init();
  },
  mounted() {},
  updated() {},
  methods: {
    init() {}
  },
  computed: {},
  watch: {},
  filters: {}
};
</script>

<style lang="scss" scoped>
.wrapper { padding: 0 2rem; }
::v-deep .plugin-wrapper .item-master { margin: 0 10px; }
// 320px - Mobile S
@media only screen and (min-width: 20rem) {}
// 375px - Mobile M
@media only screen and (min-width: 23.4375rem) {}
// 425px - Mobile L
@media only screen and (min-width: 26.5625rem) {}
// 768px - Tablet
@media only screen and (min-width: 48rem) {}
// 1024px - Laptop
@media only screen and (min-width: 64rem) {}
// 1200px - 
@media only screen and (min-width: 75rem) {}
// 1440px - Laptop L
@media only screen and (min-width: 90rem) {}
// 2560px - 4K
@media only screen and (min-width: 160rem) {}
// IE10 & IE11
@media (-ms-high-contrast: active), (-ms-high-contrast: none) {}
// Microsoft Edge 12+
@supports (-ms-ime-align: auto) {}
// Edge 12 & 13
@supports (-ms-accelerator: true) {}
// Edge 13+
@supports (-ms-ime-align: auto) and (color: unset) {}
</style>